import axios from 'axios';

const instance = axios.create({
	//timeout setting
	timeout: 300000
});

export default instance;
